import { UserRequestSimpleFin } from '@liquidbudget/common';
import { Button } from '@/components/ui/button';
import { TextField } from '@/components/ui/field/text-field';
import { Form } from '@/components/ui/form/form';
import { useUserSimpleFinForm } from '@/pages/dashboard/account-settings/bank-import/use-user-simple-fin-form';
import { ExternalLink, LinkIcon } from 'lucide-react';

interface Props {
  onSuccess: () => void;
}

export function UserSimpleFinForm({ onSuccess }: Props) {
  const { form, onSubmit, isSubmitting } = useUserSimpleFinForm({ onSuccess });

  return (
    <>
      <div className="space-y-6  p-6 rounded-lg m-5  border border-gray-200 p-8 rounded-lg shadow-sm ">
        <div className="flex items-center gap-3 border-b border-gray-200 pb-4">
          <LinkIcon className="h-6 w-6 text-primary" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Setup Guide</h2>
        </div>

        <ol className="space-y-6">
          <li className="flex items-start gap-4">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-white text-sm font-medium">
              1
            </span>
            <div className="space-y-1">
              <a
                href="https://beta-bridge.simplefin.org/search-institutions"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-primary hover:text-primary/80 font-medium transition-colors"
              >
                Check if your bank is supported <ExternalLink className="h-4 w-4" />
              </a>
              <p className="text-sm text-gray-600">View the list of supported financial institutions</p>
            </div>
          </li>

          <li className="flex items-start gap-4">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-white text-sm font-medium">
              2
            </span>
            <div className="space-y-1">
              <a
                href="https://beta-bridge.simplefin.org"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-primary hover:text-primary/80 font-medium transition-colors"
              >
                Create a SimpleFIN account <ExternalLink className="h-4 w-4" />
              </a>
              <p className="text-sm text-gray-600">Create a SimpleFIN account to manage your connections</p>
            </div>
          </li>

          <li className="flex items-start gap-4">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-white text-sm font-medium">
              3
            </span>
            <div className="space-y-1">
              <p className="font-medium">Link your bank accounts in SimpleFIN</p>
              <p className="text-sm text-gray-600">
                Follow SimpleFIN's secure process to connect to your financial institutions
              </p>
            </div>
          </li>

          <li className="flex items-start gap-4">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-white text-sm font-medium">
              4
            </span>
            <div className="space-y-1">
              <p className="font-medium">Create a SimpleFIN App Connection</p>
              <p className="text-sm text-gray-600">Create a new app called Liquid Budget and copy the setup token</p>
            </div>
          </li>
        </ol>
      </div>

      <Form {...form}>
        <form onSubmit={onSubmit} className="space-y-6 m-5 mt-0">
          <TextField<UserRequestSimpleFin>
            form={form}
            name="token"
            label="SimpleFIN Setup Token"
            placeholder="Paste your SimpleFIN setup token here"
          />
          <div className="flex justify-end gap-3 pt-2">
            <Button type="submit" isLoading={isSubmitting} className="min-w-[100px]">
              Connect Banks
            </Button>
          </div>
        </form>
      </Form>
    </>
  );
}
